
import { mapState } from 'vuex'
import utils from '@/components/tools/utils'
import catalog from '@/components/tools/catalog'

export default {
  props: {
    status: {
      type: String,
      default: undefined
    },
    endingAt: {
      type: Number,
      default: undefined
    },
    small: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    label: {
      type: Boolean,
      default: false
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    maybeHideIcon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: undefined
    },
    anrOfferAboveTargetPrice: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hotbiddingEntered: false,
    now: Date.now(),
    interval: undefined
  }),

  computed: {
    ...mapState('general', ['differenceToServerTime']),
    hotBiddingActive () {
      return this.hotbiddingEntered || utils.lessThan30SecondsUntilThen(this.now, this.endingAt)
    },
    hideIconInLateOffer () {
      return this.status === 'recd_late_offer' && this.maybeHideIcon
    },
    show () {
      if (['acpt_late_offer', 'failed_na'].includes(this.status) && this.isOwner) {
        return false
      }

      return true
    },

    value () {
      return catalog.getAuctionStatusLabel(this.status, this.hotBiddingActive, this, this.isOwner, this.anrOfferAboveTargetPrice)
    },
    color () {
      return catalog.getAuctionStatusColor(this.status, this.hotBiddingActive, this.anrOfferAboveTargetPrice)
    },

    icon () {
      return catalog.getAuctionStatusIcon(this.status, this.hotBiddingActive)
    },
    blinking () {
      switch (this.status) {
        case 'running':
          if (this.hotBiddingActive) {
            return 'blinking-fast'
          } else {
            return ''
          }
        default:
          return ''
      }
    }
  },
  watch: {
    hotBiddingActive (value) {
      if (value === true) {
        this.hotbiddingEntered = true
      }
    }
  },
  mounted () {
    const that = this
    this.interval = setInterval(function () {
      that.now = Date.now() - that.differenceToServerTime
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
